import { ServiceAuthType, ServiceProvider } from '../..';

export class Credential {
  constructor(
    public readonly authType: ServiceAuthType,
    public readonly provider: ServiceProvider,
    public readonly accessToken: string,
    public readonly expiresAt: number,
    public readonly refreshToken: string,
    public readonly scopes: string[],
    public readonly metadata: Record<string, any>,
  ) {}

  public get isExpired(): boolean {
    const expireBuffer = 5 * 60 * 1000; // 5 minutes
    return Date.now() >= this.expiresAt - expireBuffer;
  }
}
